import React from 'react'
import classnames from 'classnames'
import Grid from '@material-ui/core/Grid'
import TextGradient from '../gradient'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import identity from '../../themes/default/brand/identity'

import styles from './styles'

const Strap = withStyles(styles)(props => {

  const { classes, uid, title, subtitle, published } = props

  return (
    <div className={classes.strap}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container spacing={40}>
            <Grid item xs={12}>
              <Typography className={classes.subtitle} gutterBottom>
                {title.text}
              </Typography>
              <Typography className={classes.title} gutterBottom>
                <TextGradient
                  text={subtitle.text}
                  fromColor={identity[uid].from}
                  toColor={identity[uid].to}
                  direction="left"
                />
              </Typography>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(Strap)



// WEBPACK FOOTER //
// ./src/components/strap/index.js